export const EMAILING_TABS = [
  {
    label: "createTemplate",
    title: "emailingSettingsTitle",
    path: "/emailing/templates",
  },
  {
    label: "assignTemplate",
    title: "assignTemplate",
    path: "/emailing/assign",
  },
  {
    label: "emailingSettings",
    title: "emailingSettingsTitle",
    path: "/emailing/settings",
  },
];

export const DEFAULT_TAB = EMAILING_TABS[0];
